import { Component, ViewEncapsulation } from '@angular/core';
import { DspxCardSetBaseFormComponent } from 'dspx-core';

// This is the same as the <dspx-card-set-base-form> component, except that its HTML template
// does not include the <dspx-dialog> and <dspx-spinner> child components.
// The purpose of this component is to allow multiple of them to be used within a parent component,
// to be able to display multiple forms at the same time.
// The <dspx-dialog> and <dspx-spinner> child components are excluded because multiple instances of them would cause the forms to behave incorrectly.
// For example, the dialog popups would appear multiple times.
// A typical usage of this component would be the following:
//
//    <!-- This is the "header" form, which provides the <dspx-dialog> and <dspx-spinner> functionality only once -->
//    <dspx-card-set-base-form #headerForm ...></dspx-card-set-base-form>
//
//    <!-- These are one or more "content" forms, which do not have <dspx-dialog> and <dspx-spinner>
//    <ists-multi-form-compatible-card-set-form #contentForm1 ...></ists-multi-form-compatible-card-set-form>
//    ...
//

@Component({
  selector: 'app-multi-form-compatible-card-set-form',
  templateUrl: './multi-form-compatible-card-set-form.component.html',
  encapsulation: ViewEncapsulation.None
})
export class MultiFormCompatibleCardSetFormComponent extends DspxCardSetBaseFormComponent  {
}
